import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_331: DocMigration = {
  maxSchemaVersion: "0.0.331",
  description: "Add missing entityType to planSetTemplateConfigs table entities",
  apply(json: any) {
    for (const id in json.planSetTemplateConfigs) {
      json.planSetTemplateConfigs[id] = {
        ...json.planSetTemplateConfigs[id],
        entityType: "PLAN_SET_TEMPLATE_CONFIG",
      };
    }
    return json;
  },
};

export default migration_0_0_331;
